<template>
  <router-view />
</template>

<script>
/**
 * Pembungkus rute /admin/login.
 *
 * KENAPA ISINYA KOSONG
 * Versi sebelumnya membungkus halaman masuk dalam susunan dua kolom:
 *
 *     .login-layout { height: 100vh; display: flex; background-image: ... }
 *     .login-form   { width: 30% }
 *
 * Padahal LoginPage.vue SUDAH merupakan halaman utuh — ia punya
 * `min-height: 100vh`, latar sendiri, dan kartu yang dipusatkan dengan
 * `max-width: 440px`. Menempatkannya di dalam kolom 30% menimbulkan dua
 * masalah:
 *
 *   1. Di layar lebar, kartunya terdorong ke kolom sempit dan latar
 *      halamannya tertimpa gambar milik pembungkus.
 *   2. Di ponsel, 30% dari lebar layar hanya sekitar 110 piksel. Kartunya
 *      lebih lebar dari itu, lalu terpotong oleh `height: 100vh` milik
 *      pembungkus. Hasilnya layar yang tampak KOSONG — tanpa pesan galat
 *      dan tanpa catatan apa pun di konsol, jadi mudah dikira situsnya
 *      gagal dimuat.
 *
 * Karena itu pembungkusnya dikosongkan, bukan sekadar diperbaiki gayanya.
 * Satu halaman sebaiknya hanya punya satu pemilik tata letak; kalau
 * dua-duanya mengatur tinggi dan lebar, yang menang bukan yang paling
 * benar melainkan yang paling luar.
 *
 * Rutenya tetap dipertahankan supaya alamat /admin/login tidak berubah.
 */
export default {
  name: 'LoginLayout',
};
</script>
